import { render, staticRenderFns } from "./addImg.vue?vue&type=template&id=0cb17818&"
import script from "./addImg.vue?vue&type=script&lang=js&"
export * from "./addImg.vue?vue&type=script&lang=js&"
import style0 from "./addImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports